// Classic Peterbilt/Kenworth Style Semi-Truck with Tall Stacks
export const ClassicSemiTruck = ({ className = "w-6 h-6", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    {/* Tall exhaust stacks */}
    <line x1="7" y1="10" x2="7" y2="2" strokeWidth="2" />
    <line x1="9" y1="10" x2="9" y2="2" strokeWidth="2" />
    <circle cx="7" cy="2" r="0.8" fill="currentColor" />
    <circle cx="9" cy="2" r="0.8" fill="currentColor" />
    
    {/* Hood - long nose classic style */}
    <path d="M2 16V12L4 10H12V16H2Z" strokeWidth="1.5" />
    
    {/* Grille - vertical slats */}
    <line x1="3" y1="11" x2="3" y2="15" strokeWidth="1" />
    <line x1="4.5" y1="10.5" x2="4.5" y2="15" strokeWidth="1" />
    <line x1="6" y1="10.5" x2="6" y2="15" strokeWidth="1" />
    <line x1="7.5" y1="10.5" x2="7.5" y2="15" strokeWidth="1" />
    <line x1="9" y1="10.5" x2="9" y2="15" strokeWidth="1" />
    <line x1="10.5" y1="10.5" x2="10.5" y2="15" strokeWidth="1" />
    
    {/* Cab/Sleeper */}
    <rect x="12" y="8" width="5" height="8" strokeWidth="1.5" />
    <line x1="12" y1="11" x2="17" y2="11" strokeWidth="0.8" />
    
    {/* Window */}
    <rect x="13" y="9" width="3" height="1.5" strokeWidth="0.8" />
    
    {/* Bumper */}
    <path d="M1 16h11" strokeWidth="2" />
    
    {/* Fuel tank */}
    <rect x="12" y="13" width="2" height="3" rx="0.5" strokeWidth="0.8" />
    
    {/* Frame rail to back */}
    <line x1="17" y1="15" x2="22" y2="15" strokeWidth="1.5" />
    
    {/* Front wheel - chrome style */}
    <circle cx="5" cy="18" r="2.5" strokeWidth="1.5" />
    <circle cx="5" cy="18" r="1" strokeWidth="0.8" />
    
    {/* Drive wheels */}
    <circle cx="15" cy="18" r="2.5" strokeWidth="1.5" />
    <circle cx="15" cy="18" r="1" strokeWidth="0.8" />
    
    {/* Headlights */}
    <circle cx="2.5" cy="13" r="0.8" fill="currentColor" />
    <circle cx="2.5" cy="14.5" r="0.5" fill="currentColor" />
  </svg>
);

export default ClassicSemiTruck;
